/**
 * VSPC UI API
 * Internal API
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum MonthsRepresentation {
    January = 'january',
    February = 'february',
    March = 'march',
    April = 'april',
    May = 'may',
    June = 'june',
    July = 'july',
    August = 'august',
    September = 'september',
    October = 'october',
    November = 'november',
    December = 'december'
};

